export default "__VITE_ASSET__e3703104__"